<template>
  <div class="dashboard">
    <layout>
      <md-app-content v-if="loaded && $material.locale">
        <h1 class="dashboard__title">Abrechnung</h1>
        <div class="dashboard__card">
          <div class="dashboard__field">
            <md-datepicker v-model="selectedDateStart" md-immediately></md-datepicker>
          </div>
          <div>bis</div>
          <div class="dashboard__field">
            <md-datepicker v-model="selectedDateEnd" md-immediately></md-datepicker>
          </div>
        </div>
        <div class="dashboard__button">
          <md-progress-spinner v-if="loading" :md-diameter="40" :md-stroke="3" md-mode="indeterminate" class="dashboard__spinner"></md-progress-spinner>
          <button v-if="!loading && selectedDateStart && selectedDateEnd" type="submit" class="button" @click="downloadPdf()">PDF Download</button>
        </div>
      </md-app-content>
    </layout>

    <snackbar></snackbar>
  </div>
</template>

<script>
    // @ is an alias to /src
    import dashboardApi from '../api/dashboard';
    import {mapGetters, mapActions} from 'vuex'
    import Layout from '../components/Layout'
    import Snackbar from '../components/Snackbar'

    export default {
        components: {
            Layout,
            Snackbar
        },
        name: 'dashboard',
        data() {
            return {
                loading: false,
                selectedDateStart: new Date(),
                selectedDateEnd: new Date(),
                locale: {
                    startYear: 2019,
                    endYear: 2099,
                    dateFormat: 'dd.MM.yy',
                    days: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
                    shortDays: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
                    shorterDays: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
                    months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
                    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
                    shorterMonths: ['J', 'F', 'M', 'A', 'M', 'Ju', 'Ju', 'A', 'Se', 'O', 'N', 'D'],
                    firstDayOfAWeek: 1
                },
            }
        },
        computed: {
            ...mapGetters('dashboard', [
                'loaded',
                'location'
            ]),
            dateFormat: {
                get () {
                    return this.$material.locale.dateFormat
                },
                set (val) {
                    this.$material.locale.dateFormat = val
                }
            },
            selectedDates: function () {
                return this.formatDate(this.selectedDateStart) + '-' + this.formatDate(this.selectedDateEnd)
            }
        },
        methods: {
            ...mapActions('auth', [
                'logout'
            ]),
            downloadPdf: async function () {

                this.loading = true

                let response = await dashboardApi.getPdf(this.location.id, this.selectedDates)

                let blob = new Blob([response.data], { type: 'application/pdf' })
                let link = document.createElement('a')
                const blobURL = window.URL.createObjectURL(blob)
                link.href = blobURL;
                const filename = 'Abrechnung_' + this.location.name + '_' + this.formatDate(this.selectedDateStart) + '-' + this.formatDate(this.selectedDateEnd) +'.pdf'

                link.setAttribute('download', filename);
                if (typeof link.download === 'undefined') {
                    link.setAttribute('target', '_blank')
                }
                document.body.appendChild(link)
                link.click();
                document.body.removeChild(link)
                setTimeout(() => {
                    // For Firefox it is necessary to delay revoking the ObjectURL
                    window.URL.revokeObjectURL(blobURL);
                }, 100);

                /* reset loading*/
                this.loading = false
            },
            formatDate: function(date) {
                let d = new Date(date),
                    month = '' + (d.getMonth() + 1),
                    day = '' + d.getDate(),
                    year = d.getFullYear();

                if (month.length < 2)
                    month = '0' + month;
                if (day.length < 2)
                    day = '0' + day;

                return [year, month, day].join('');
            }
        },
        mounted() {
            this.$material.locale = this.locale
        }
    }
</script>

<style lang="scss">
  .dashboard__spinner {
    position: absolute;
    left: 50%;
    top: 45%;
    transform: translate(-50%, -50%);
  }
</style>
